import React, { useState } from 'react';
import TextField from '@material-ui/core/TextField';
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import { Link } from 'react-router-dom';
import { makeStyles } from "@material-ui/core/styles";
import { RECOVER_PASSWORD_ADMIN, SIGNUP, LANDING_PAGE_300 } from '../../../../../routes';
import Footer from '../../Footer';
import ButtonBase from '../../../../../components/Buttons/ButtonBase';
import { withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import './SignInAdmin.scss'
import {
  isBrowser,
  isMobile,
} from 'react-device-detect';





const useStyles = makeStyles(theme => ({
  appBar: {
    backgroundColor: "white",
    boxShadow: "none",
    maxHeight: 38
  },
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    maxWidth: 904,
    margin: "auto"
  },
  tabs: {
    minHeight: 24
  },

  tabStyle: {
    maxWidth: 168,
    minWidth: "20%",
    height: 24,
    padding: "0 12px",
    fontSize: 14,
    fontWeight: "bold",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "normal",
    letterSpacing: "normal",
    textAlign: "center",
    textTransform: "none",
    borderBottom: "1px solid #e7e7e7",
    "&$selected": {
      color: "#013957"
    },
    '@media (max-width: 424px)': {
      width: 140
    }
  },
  selected: {},
  textColorPrimary: {
    color: "#c1c1c1"
  },
  indicator: {
    height: 2,
    backgroundColor: "#013957"
  },
  tabsContainer: {
    width: "fit-content",
    margin: "auto"
  },
  scrollButtonsDesktop: {
    color: "#013957",
    display: "none",
    '@media (max-width: 890px)': {
      display: "inherit"
    },
    "&>svg": {
      fontSize: 24
    }
  },
  panel: {
    position: "relative"
  },
  colorGrayIcon: {
    color: '#c1c1c1',
    padding: 0
  },
  TextField: {
    maxWidth: '336px'
  },
}));


function a11yProps(index) {
  return {
    id: `scrollable-auto-tab-${index}`,
    'aria-controls': `scrollable-auto-tabpanel-${index}`,
  };
}


const FromSignIn = props => {
  const {
    values, handleSubmit, handleChange,
    touched, dirty, handleBlur, errors, isValid,
  } = props;
  const classes = useStyles();

  const [valuesPass, setValuesPass] = useState({
    password: '',
    showPassword: false,
  });

  const [value, setValue] = useState(0);


  const handleChangeTab = (event, newValue) => {
    setValue(newValue);
  };

  const handleChangePass = prop => event => {
    setValuesPass({ ...valuesPass, [prop]: event.target.value });
  };

  const handleClickShowPassword = () => {
    setValuesPass({ ...valuesPass, showPassword: !valuesPass.showPassword });
  };

  const handleMouseDownPassword = event => {
    event.preventDefault();
  };



  return (
    <div className="FromSignInAdmin">

      <form className="container-box">

        <div className="FromSignInAdmin_header_login">
          <figure className="FromSignInAdmin_close">
          {isMobile ? 
           ( <img src="/img/icons/close.svg" alt="close" />) : '' }
          </figure>

          <figure className="FromSignInAdmin_logo" >
            <img src="/img/Logo-box.svg" alt="logo" />
          </figure>
          <p className="FromSignInAdmin_title">Iniciar sesión</p>
        </div>


        <div className="FromSignInAdmin_body_login">


          <div className="container-main">



            <div>
              <div>
                <TextField
                  label="Correo"
                  type="email"
                  id="email"
                  variant="outlined"
                  classes={{ root: classes.TextField }}
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.email}
                  helperText={touched.email && errors.email ? errors.email : ''}
                  error={touched.email && errors.email ? true : false}
                />
              </div>
              <div>
                <TextField
                  id="outlined-adornment-password"
                  variant="outlined"
                  type={valuesPass.showPassword ? 'text' : 'password'}
                  label="Contraseña"
                  name="password"
                  classes={{ root: classes.TextField }}
                  value={values.password}
                  onBlur={handleBlur}
                  onChange={handleChange}
                  helperText={
                    touched.password && errors.password ? errors.password : ''
                  }
                  error={touched.password && errors.password ? true : false}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="Toggle password visibility"
                          onClick={handleClickShowPassword}
                          classes={{
                            root: classes.colorGrayIcon
                          }}
                        >
                          {valuesPass.showPassword ? (
                            <VisibilityOff />
                          ) : (
                              <Visibility />
                            )}
                        </IconButton>
                      </InputAdornment>
                    )
                  }}
                />
              </div>
              <div>
                <div className="container-forget-password">
                  <Link to={RECOVER_PASSWORD_ADMIN}>
                    <p className="text-forget-password">
                      ¿Olvidaste tu contraseña?
              </p>
                  </Link>
                </div>
              </div>
            </div>

            <div className="horizontal-layout" style={{ marginTop: 15 }}>
              <ButtonBase
                type="submit"
                onClick={handleSubmit}
                variant="primary"
                disabled={!isValid}
              >
                Ingresar
              </ButtonBase>
            </div>
          </div>
        </div>
        

        {/* 
        <div className="container-main">

      

          <div>
            <div>
              <TextField
                label="Correo"
                type="email"
                id="email"
                variant="outlined"
                classes={{ root: classes.TextField }}
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.email}
                helperText={touched.email && errors.email ? errors.email : ''}
                error={touched.email && errors.email ? true : false}
              />
            </div>
            <div>
              <TextField
                id="outlined-adornment-password"
                variant="outlined"
                type={valuesPass.showPassword ? 'text' : 'password'}
                label="Contraseña"
                name="password"
                classes={{ root: classes.TextField }}
                value={values.password}
                onBlur={handleBlur}
                onChange={handleChange}
                helperText={
                  touched.password && errors.password ? errors.password : ''
                }
                error={touched.password && errors.password ? true : false}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="Toggle password visibility"
                        onClick={handleClickShowPassword}
                        classes={{
                          root: classes.colorGrayIcon
                        }}
                      >
                        {valuesPass.showPassword ? (
                          <VisibilityOff />
                        ) : (
                            <Visibility />
                          )}
                      </IconButton>
                    </InputAdornment>
                  )
                }}
              />
            </div>
            <div>
              <div className="container-forget-password">
                <Link to={RECOVER_PASSWORD}>
                  <p className="text-forget-password">
                    ¿Olvidaste tu contraseña?
                        </p>
                </Link>
              </div>
            </div>
          </div>

          <div className="horizontal-layout" style={{ marginTop: 15 }}>
            <ButtonBase
              type="submit"
              onClick={handleSubmit}
              variant="primary"
            // disabled={!isValid}
            >
              Ingresar
                    </ButtonBase>
          </div>
        </div>
        <Footer
          margin="20px 0px 20px"
          text="¿No tienes una cuenta?"
          textLink="Registrate"
          linkTo={SIGNUP}
        />

         */}
      </form>
    </div >

  );
}

export default (FromSignIn)